module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"System Management","tab":{"backups":"Backups","audits":"Server Audit Logs"}}}')
  delete Component.options._Ctor
}
